import React from "react";
import { Link } from "react-router-dom";
import { style } from "typestyle";
import { paths } from "../../App";
import { EventListItem } from "../../types";
import { EventListItem as EventListBox } from "@hooplab/ui-components";
import { FormattedMessage } from "react-intl";
import { useCurrentLangContext } from "../../hooks/useCurrentLang";
import { getDomain } from "../../environment";

const availabilityTexts = {
  FEW_LEFT: (
    <FormattedMessage id="components.Cart.TicketTypeRow.fewLeftLabel" defaultMessage={"Few left"} />
  ),
  NO_RESERVABLE: (
    <FormattedMessage id="components.Cart.TicketTypeRow.fewLeftLabel" defaultMessage={"Few left"} />
  ),
  SOLD_OUT: (
    <FormattedMessage id="components.Cart.TicketTypeRow.soldOutLabel" defaultMessage={"Sold out"} />
  ),
  MANY_LEFT: null,
};

type EventListItemProps = EventListItem;

const EventListItemView: React.FC<EventListItemProps> = ({
  eventId,
  identifier,
  title,
  subtitle,
  location,
  start,
  end,
  image,
  images,
  dateFormat,
  availability,
}) => {
  const {
    provided: {
      currentLocale: { name: lang },
    },
  } = useCurrentLangContext()!;

  if (identifier) {
    const redirectURL = `https://${identifier}.${getDomain()}/event/${eventId}`;
    return (
      <a
        href={redirectURL}
        rel="noreferrer noopener"
        target="_blank"
        className={style({ $nest: { "&:hover": { textDecoration: "none" } } })}
      >
        <EventListBox
          title={title}
          subtitle={subtitle}
          locale={lang}
          location={location}
          availability={availability}
          availabilityTexts={availabilityTexts}
          timeZoneAdjustedStart={start}
          timeZoneAdjustedEnd={end}
          image={image}
          images={images}
          dateFormat={dateFormat}
          env={window.ENVIRONMENT.__IMGIX_ENV__}
        />
      </a>
    );
  }

  return (
    <Link
      to={paths.event(eventId)}
      className={style({ $nest: { "&:hover": { textDecoration: "none" } } })}
    >
      <EventListBox
        title={title}
        subtitle={subtitle}
        location={location}
        locale={lang}
        availability={availability}
        availabilityTexts={availabilityTexts}
        timeZoneAdjustedStart={start}
        timeZoneAdjustedEnd={end}
        image={image}
        images={images}
        dateFormat={dateFormat}
        env={window.ENVIRONMENT.__IMGIX_ENV__}
      />
    </Link>
  );
};

export default EventListItemView;
